import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import { useMediaQueries } from "shared";

import { Subtitle } from "../../../components";
import { Legend } from "./Legend";
import StatsContainer from "./StatsContainer";
import { TaskOverviewProps } from "./types";

const TaskOverview = ({ data, isLoading }: TaskOverviewProps) => {
    const { t } = useTranslation();
    const { toLg } = useMediaQueries();

    return (
        <div
            css={css({
                flex: "1",
                paddingLeft: "24px"
            })}
        >
            <Subtitle text={t("Dashboard##title##task overview")} />
            <StatsContainer data={data} isLoading={isLoading} />

            {toLg && (
                <Legend
                    customStyles={{
                        marginTop: "16px",
                        justifyContent: "center",

                        "@media (max-width: 599px)": {
                            justifyContent: "unset",
                            flexDirection: "column",
                            rowGap: "8px"
                        }
                    }}
                />
            )}
        </div>
    );
};

export default TaskOverview;
export { Legend } from "./Legend";
